import {dispatch} from '@wordpress/data';
import {useEffect} from '@wordpress/element';



/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {

	/**
	 * [_dispatchYearFrom description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	function _dispatchYearFrom(e) {
		const storyYearFrom = e.target.value;
		jQuery('#form_stories_field_year_from').val(storyYearFrom);
	} 

	let years = [];
    

	if (props.years) {
		years = Object.entries(props.years).map(([id, value]) => {					                		
				var year_current = jQuery('#form_stories_field_year_from').val(); 
				if (value == year_current) { 
					return <option value={value} selected="selected">{value}</option>
				}
				return <option value={value}>{value}</option>
			}
		)
	}
 
	return (				
		<div className="search-filter form-field stories-search-filter-date-from">
            <select onChange={(e) => _dispatchYearFrom(e)}>
                <option value="0">All</option>
                {years}
            </select>
            <span className="input-span">
	        	<span className="icons-svg icons-svg-caret-bottom"></span>
	        </span>	
		</div>
	);

}